import http from '@frontend/api/http';
import { MESSAGING_SERVICE_URL } from '@frontend/envConfig';

/**
 * Get-or-create semantics: a caller who already has a DM with `participantId`
 * gets that conversation back, so this is safe to call on every click, not
 * just the first one. `participantId` is any OptiID user id — a VAU's
 * `optiid_user_id` is one, since VAUs are OptiID users like any other.
 */
export async function createDMConversation(participantId: string) {
  const res = await http.post<{ id: string }>(`${MESSAGING_SERVICE_URL}/api/v1/conversations`, {
    type: 'dm',
    participant_id: participantId,
  });
  return res.data;
}
